export const columnTranslations: Record<string, string> = {
  id: "ID",
  user_name: "Usuário",
  type_request: "Tipo de Requisição",
  type_solicitation: "Tipo de Solicitação",
  details: "Detalhes",
  created_at: "Criado Em",
};
